import { FormGroup, Input, Label } from "reactstrap";
import { handleFormChange } from "../../../components/modals/EditableTable";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ContainerVisual from "../../../components/formatted/LoadImages";
import { CONTAINERS_TYPES } from "../../container/containerFormTab/ContainerPreview";

const UnitField = ({ unit, children }) => (
  <div className="relative w-full">
    {children}
    <span className="zone-settings__unit-suffix">{unit}</span>
  </div>
);

/**
 * Carte Dimensions – Type de contenant *, image, Volume * (m3).
 */
const ZoneSettingsDimensions = ({ formData, setFormData, setErrorForm }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const hasVolume = formData.volume && formData.volume > 0;
    if (!hasVolume) {
      setErrorForm?.(t("containerSettings.pleaseVolumeOrDimensions"));
    } else {
      setErrorForm?.("");
    }
  }, [formData.volume, setErrorForm, t]);

  const onVolumeChange = (e) => {
    const value = e.target.value;
    const num = value !== "" ? parseFloat(value) : 0;
    setFormData((prev) => ({ ...prev, volume: num }));
    setErrorForm?.(
      num > 0 ? "" : t("containerSettings.pleaseVolumeOrDimensions"),
    );
  };

  const inputClass = (disabled) =>
    `w-full ${disabled ? "bg-gray-100" : "bg-white"} zone-settings__input border border-gray-300 rounded-lg block px-3`;

  return (
    <div className="flex flex-col w-full">
      {/* Type de contenant * – valeur normalisée pour affichage */}
      <FormGroup className="mb-2">
        <Label className="zone-settings__label">
          {t("containerSettings.containerType")}{" "}
          <span className="zone-settings__required">*</span>
        </Label>
        <Input
          className="zone-settings__input w-full bg-white border border-gray-300 rounded-lg"
          type="select"
          value={
            formData.type == null || formData.type === ""
              ? "unknown"
              : String(formData.type)
          }
          onChange={(e) => handleFormChange(e, formData, setFormData)}
          name="type"
        >
          <option value="unknown">{t("containerSettings.notSpecified")}</option>
          {CONTAINERS_TYPES.map((type, index) => (
            <option value={type.value} key={type.value || index}>
              {type.label}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Image – cadre maquette: bordure fine, fond blanc, padding */}
      <div className="zone-settings__image-frame">
        <div className="image-inner">
          <ContainerVisual type={formData.type} height="180px" width="60%" />
        </div>
      </div>

      {/* Volume * avec m3 à droite */}
      <FormGroup className="mb-0 mt-3">
        <Label className="zone-settings__label">
          {t("Volume")} <span className="zone-settings__required">*</span>
        </Label>
        <UnitField unit="m3">
          <Input
            className={`${inputClass(false)} pr-12`}
            type="number"
            placeholder="100"
            value={formData.volume > 0 ? formData.volume : ""}
            onChange={onVolumeChange}
            name="volume"
            step={0.01}
          />
        </UnitField>
      </FormGroup>
    </div>
  );
};

export default ZoneSettingsDimensions;
